import { Component, OnInit } from '@angular/core';
import { AppConstant } from '../common/app.constant';
import { IConfirmationDialogModel } from '../models/confirmaDialogModel';
import { DisplayStatus } from '../models/displaystatus.enum';
import { EICSTatus } from '../models/eic-status.enum';
import { FilterStatus } from '../models/filterstatus.enum';
import { Source } from '../models/source.enum';
import { Status } from '../models/status.enum';
import { ITrackAuthority, TrackAuthority } from '../models/trackauthority';
import { ChangeRequestService } from '../services/changerequest.service';
import { DataService } from '../services/data.service';
import { ATMEventData, EventBusService, EventType } from '../services/eventbus.service';
import { SystemStatusService } from '../services/systemstatus.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ProxyUser } from '../models/proxyuser';
import { AuthenticationService, User } from '@csx/security';
import { LocalStorageService } from '../services/localstorage.service';
import { SelectItem } from 'primeng/api';

declare const csxAuth: any;

@Component({
  selector: 'main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  DisplayStatus = DisplayStatus;
  FilterStatus = FilterStatus;
  blocked: boolean = true;
  title: string = 'My Authorities';
  authorities: Array<TrackAuthority> = [];
  lastUpdated: Date;

  authorityForCopyAndResubmit: TrackAuthority = null;
  authorityForUserConfirmation: TrackAuthority = null;
  authorityForComment: TrackAuthority = null;
  authorityForChangeRequest: TrackAuthority = null;
  showSharedAuthorityModal: boolean = false;
  actionForUserConfirmation: Status | Source = Status.AUTHORITY_USER_APPROVED;
  displayRequestAuthority = false;
  selectedFilterStatus: FilterStatus;
  filterStatusList: SelectItem[];
  private firstLoad: boolean = true;
  trackAuthorityModal: TrackAuthority;
  sharedAuthorityNotification: Object;
  showConfirmation: boolean = false;
  confirmationDialogData: IConfirmationDialogModel;

  constructor(private dataService: DataService, private eventBus: EventBusService, private _systemStatusService: SystemStatusService,
    private router: Router, private routeactive: ActivatedRoute, private proxy: ProxyUser, private user: User,
    private authService: AuthenticationService, private changeRequestService: ChangeRequestService,  private localStorageService: LocalStorageService) {
    eventBus.getEventBus(EventType.AUTHORITY_UPDATED_EVENT).subscribe(response => this.handleUpdateSuccess(response.data));
  }

  ngOnInit(): void {
    this.routeactive.queryParams?.subscribe(queryParams => {
      this.selectedFilterStatus = queryParams['status'] ? queryParams['status'].toUpperCase() : FilterStatus.OPEN;
    });
    this.lastUpdated = new Date();
    this.eventBus.fireEvent(EventType.RESET_POLL_EVENT, new ATMEventData(null, () => ''));
    if (!this.systemState.state) {
      this.localStorageService.getAllTrackAuthorities().then(response => {
        this.userListUpdated(response);
      });
    }
    this.eventBus.getEventBus(EventType.AUTHORITY_POLL_EVENT).subscribe(response => {
      this.userListUpdated(response.data as TrackAuthority[]);
      this.lastUpdated = new Date();
    });
    this.eventBus.getEventBus(EventType.BLOCK_UI_EVENT).subscribe(resposne => {
      this.blocked = true;
    });
    this.eventBus.getEventBus(EventType.RELEASE_UI_EVENT).subscribe(resposne => {
      this.blocked = false;
    });
    this.filterStatusList = [
      { label: 'Open', value: FilterStatus.OPEN },
      { label: 'Released', value: FilterStatus.RELEASED },
      { label: 'Cancelled', value: FilterStatus.CANCELLED },
      { label: 'Rejected', value: FilterStatus.REJECTED }
    ];
  }

  get systemState(): SystemStatusService {
    return this._systemStatusService;
  }

  onCloseSharedModal(value: boolean) {
    this.showSharedAuthorityModal = value;
  }

  logOut(): void {
    csxAuth.logout();
    event.preventDefault();
  }

  openUserConfirmationDialog(trackauthority: TrackAuthority, action: Status | Source): void {
    this.authorityForUserConfirmation = trackauthority;
    this.actionForUserConfirmation = action;
  }

  userAccepted(trackAuthority: TrackAuthority): void {
    this.authorityForUserConfirmation = null;
    if (this.actionForUserConfirmation === Source.TRANSFER_TO_PAPER) {
      this.dataService.transferAuthority(trackAuthority, this.actionForUserConfirmation);
    } else if (this.actionForUserConfirmation === Status.CHANGE_USER_APPROVED) {
      this.dataService.updateChangeRequestStatus(trackAuthority, this.actionForUserConfirmation as Status);
    } else if (this.actionForUserConfirmation === Status.SHARING_RELEASE) {
      if (
        trackAuthority.eicChangeRequests[(this.proxy.racf || this.user.racf)] &&
        trackAuthority.eicChangeRequests[(this.proxy.racf || this.user.racf)].authorityChangeRequestStatus ===
        Status.UNSHARING_INITIATED.toString()
      ) {
        const ChangeRequest = {
          id: trackAuthority.id,
          authorityChangeRequestId: trackAuthority.eicChangeRequests[(this.proxy.racf || this.user.racf)].authorityChangeRequestId,
          status: Status.UNSHARE_ACCEPTED
        };

        const ChangeRequestBody = {
          status: Status.UNSHARE_ACCEPTED,
          confirmationAction: Status.SHARING_RELEASE,
          confirmation: trackAuthority.userConfirmationList
        };
        this.dataService.changeRequest(ChangeRequest, ChangeRequestBody, trackAuthority).then(
          data => { },
          error => {
            this.eventBus.fireEvent(
              EventType.NOTIFY_FAILURE_EVENT,
              new ATMEventData(null, () => {
                return AppConstant.ERROR_MESSAGE;
              })
            );
          }
        );
      } else if (!trackAuthority.isLoggedUserPrimary) {
        const changeRequest = {
          type: `${Status.TYPE_UNSHARE}`,
          trackAuthorityId: trackAuthority.id,
          sharingChangeModel: { secondaryEICRacf: (this.proxy.racf || this.user.racf) },
          confirmationAction: Status.SHARING_RELEASE.toString(),
          confirmationMessageList: trackAuthority.userConfirmationList
        };
        this.changeRequestService
          .postChangeRequest(changeRequest, trackAuthority)
          .then(result => {
            this.eventBus.fireEvent(EventType.AUTHORITY_UPDATED_EVENT, new ATMEventData(trackAuthority, () => { }));
          })
          .catch((error: Error) => {
            this.eventBus.fireEvent(
              EventType.NOTIFY_FAILURE_EVENT,
              new ATMEventData(null, () => {
                return AppConstant.ERROR_MESSAGE;
              })
            );
          });
      }
    } else if (this.actionForUserConfirmation === Status.RELEASE_REQUESTED) {
      this.dataService.updateAuthorityStatus(trackAuthority, this.actionForUserConfirmation as Status);
    } else {
      this.dataService.updateAuthorityStatus(trackAuthority, this.actionForUserConfirmation as Status);
    }
  }

  userCancelled(event: any): void {
    this.authorityForUserConfirmation = null;
    this.actionForUserConfirmation = Status.ACTIVE;
  }

  openRequestAuthorityDialog(trackAuthority: TrackAuthority): void {
    this.authorityForCopyAndResubmit = trackAuthority;
    this.displayRequestAuthority = true;
  }

  closeDialog(event: any): void {
    this.authorityForCopyAndResubmit = null;
    this.displayRequestAuthority = false;
  }

  private userListUpdated(userList: TrackAuthority[]): void {
    let traversed: TrackAuthority[] = this.authorities.filter(() => true);
    userList.forEach((trackAuthority: TrackAuthority) => {
      let originalAuthority: TrackAuthority = this.authorities.find(authority => authority.id === trackAuthority.id);
      if (originalAuthority === undefined) {
        this.authorities.push(trackAuthority);
      } else {
        let tempAuthority = {
          sourceSystemName: originalAuthority.sourceSystemName,
          dirty: originalAuthority.dirty
        } as TrackAuthority;

        TrackAuthority.deepCopy(trackAuthority, originalAuthority);
        if (tempAuthority.dirty) {
          originalAuthority.dirty = tempAuthority.dirty;
          originalAuthority.sourceSystemName = tempAuthority.sourceSystemName;
        }

        traversed.splice(traversed.indexOf(originalAuthority), 1);
      }
    });
    traversed.forEach(authority => this.authorities.splice(this.authorities.indexOf(authority), 1));
    this.sortAuthorities();

    if (this.firstLoad) {
      this.firstLoad = false;
      this.blocked = false;
    }
  }

  private sortAuthorities(): void {
    this.authorities.sort((a: TrackAuthority, b: TrackAuthority) => {
      if (a.displayStatus === DisplayStatus.ACTIVE && b.displayStatus !== DisplayStatus.ACTIVE) {
        return -1;
      } else if (b.displayStatus === DisplayStatus.ACTIVE && a.displayStatus !== DisplayStatus.ACTIVE) {
        return 1;
      }
      if (a.displayStatus === DisplayStatus.REJECTED && b.displayStatus !== DisplayStatus.REJECTED) {
        return 1;
      } else if (b.displayStatus === DisplayStatus.REJECTED && a.displayStatus !== DisplayStatus.REJECTED) {
        return -1;
      }
      return a.createDate <= b.createDate ? 1 : -1;
    });
  }

  private handleUpdateSuccess(updatedAuthority: ITrackAuthority) {
    let trackAuthority: TrackAuthority = this.authorities.find(
      (trackAuthority: TrackAuthority) => trackAuthority.id === updatedAuthority.id
    );
    if (trackAuthority) {
      TrackAuthority.deepCopy(new TrackAuthority(updatedAuthority, (this.proxy.racf || (this.proxy.racf || this.user.racf))), trackAuthority);
    }
    this.sortAuthorities();
  }

  createCommentRequest(trackAuthority: TrackAuthority): void {
    this.authorityForComment = trackAuthority;
  }

  onCloseCommentDialog(): void {
    this.authorityForComment = null;
  }

  createChangeRequest(trackAuthority: TrackAuthority): void {
    this.authorityForChangeRequest = trackAuthority;
  }

  onCloseChangeRequest(): void {
    this.authorityForChangeRequest = null;
  }

  showCloseModal(event) {
    this.confirmationDialogData = {
      header: AppConstant.CONFIRMATION_TEXT,
      modalHeading: '#' + event.ec1Number,
      modalSecondline: AppConstant.USER_CONFIRMATION,
      acceptLabel: AppConstant.ACCEPT_LABEL,
      rejectLabel: AppConstant.REJECT_LABEL
    };
    this.showConfirmation = true;
  }

  confirmationAccepted() {
    if (this.showConfirmation) {
      this.showConfirmation = false;
      this.onCloseChangeRequest();
    }
  }
  confirmationCancelled() {
    if (this.showConfirmation) {
      this.showConfirmation = false;
    }
  }

  private checkIfAuthorityActEIC(trackAuthority: TrackAuthority) {
    let status = false;
    trackAuthority.employeeInCharges.forEach(eic => {
      if (eic.status === EICSTatus.ACTIVE && !eic.primary) {
        status = true;
      }
    });
    return status;
  }
  updateQueryParam(event): void {
    this.router.navigate(['/authorities'], { queryParams: { status: event.option.value.toLowerCase() } });
  }
  updateQueryParams() {
    this.router.navigate(['/authorities'], { queryParams: { status: this.selectedFilterStatus.toLowerCase() } });
  }

  isAdmin() {
    return this.proxy.racf !== undefined && this.authService.isRoleAuthorized(['client.atam.admin']) &&
      !this.authService.isRoleAuthorized(['client.atam.developer']);
  }
}
